import styled from '@emotion/styled'

export const H1 = styled.h1`
  font-family: 'Soehne';
  // font-size: clamp(5.5rem, 10vw, 8.8rem);
  font-size: calc(34px + (72 - 34) * ((100vw - 300px) / (1600 - 300)));
  font-weight: 400;
  line-height: 110%;
`

export const H2 = styled.h2`
  font-family: 'Soehne';
  font-size: 3.4rem;
  font-weight: 400;
  line-height: 140%;
`

export const H3 = styled.h2`
  font-family: 'Soehne';
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 140%;
`

export const H4 = styled.h3`
  font-family: 'Soehne';
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 165%;
`

export const H5 = styled.h3`
  font-family: 'Soehne';
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  padding-bottom: 2rem;
  opacity: 0.4;
`
